import { mergeAttributes, Node, NodeViewProps } from "@tiptap/core";
import { NodeViewContent, NodeViewWrapper, ReactNodeViewRenderer } from "@tiptap/react";

// https://tiptap.dev/docs/editor/extensions/custom-extensions/node-views/react

export interface SignatureBlockOptions {
  HTMLAttributes: Record<string, any>;
}

declare module "@tiptap/core" {
  interface Commands<ReturnType> {
    signatureBlock: {
      setSignatureBlock: () => ReturnType;
    };
  }
}

const SignatureBlockComponent = (_: NodeViewProps) => {
  return (
    <NodeViewWrapper className="signature-block">
      <div className="w-full">
        <div className="flex flex-row items-end" data-alert-type={"signature-block"}>
          <div className="signature-text border-b-2 border-transparent">
            <NodeViewContent className="content" />
          </div>
          <div className="flex-1 border-b-2 border-dotted border-black mr-2.5 mb-1.5 ml-[5px]"></div>
          <div className="flex flex-row items-end">
            <div className="flex-1 border-b-2 border-dotted border-black w-10 mx-[5px] mb-1.5"></div>
            <div>/</div>
            <div className="flex-1 border-b-2 border-dotted border-black w-10 mx-[5px] mb-1.5"></div>
            <div>/</div>
            <div className="flex-1 border-b-2 border-dotted border-black w-10 mx-[5px] mb-1.5"></div>
          </div>
        </div>
      </div>
    </NodeViewWrapper>
  );
};

export const SignatureBlock = Node.create<SignatureBlockOptions>({
  name: "signature",

  group: "block",

  content: "inline*",

  marks: "",

  selectable: true,

  // this for, @Mentions, project photo, not text stuff
  // atom: true,

  addAttributes() {
    return {};
  },

  renderHTML({ HTMLAttributes }) {
    return ["div", mergeAttributes(HTMLAttributes)];
  },

  addNodeView() {
    return ReactNodeViewRenderer(SignatureBlockComponent);
  },

  addCommands() {
    return {
      setSignatureBlock:
        () =>
        ({ commands }) => {
          return commands.insertContent({ type: "signature", content: [{ type: "text", text: "Prepared By" }] });
        },
    };
  },
});
